@if (selectedQR) {
  <div class="rounded-2xl mt-2 text-md sm:text-sm">
    <sbd-account-portal-frontend-accordion-content
      [item]="selectedQR"
      [toggleAccordion]="true"
      [_cathyService]="_cathyService"
      (updatedOpenQR)="updateSelectedQuoteOption($event)"
      (cleanup)="closeParentDrawerActionEvent()"
      (getFileEvent)="getFileEvent($event)"
      (openMainDrawerEvent)="openMainDrawerEvent($event)"

    >
    </sbd-account-portal-frontend-accordion-content>
  </div>
} @else {
  <div class="rounded-2xl mt-2 text-md sm:text-sm" *ngFor="let openQR of queuedQR">
    <sbd-account-portal-frontend-accordion-content
      [item]="openQR"
      [toggleAccordion]="queuedQR.length === 1"
      (updatedOpenQR)="updateSelectedQuoteOption($event)"
      [_cathyService]="_cathyService"
      (cleanup)="closeParentDrawerActionEvent()"
      (getFileEvent)="getFileEvent($event)"
      (openMainDrawerEvent)="openMainDrawerEvent($event)">
    </sbd-account-portal-frontend-accordion-content>
  </div>
}
